import { createRoot } from 'react-dom/client'
import { LoginProvider } from 'components/providers/LoginProvider'
import './tailwind.css'

const node = document.getElementById('root')
if (node) {
  const root = createRoot(node)
  root.render(<LoginProvider />)
}
